/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Flag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Flag({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsSettings/Settings/Content/Flags/Flag",
  onChange
  
}) {
let flagValueValueData = fromData.useDataValue({ viewPath,
context: 'flag',
path: 'value',
})
let flagValueChangeData = fromData.useDataChange({ viewPath,
context: 'flag',
path: 'value',
})
let flagTextValueData = fromData.useDataValue({ viewPath,
context: 'flag',
path: 'text',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={0}
 data="flag.value"
 value={flagValueValueData}
 onChange={flagValueChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 data="flag.text"
 text={flagTextValueData}
/>
</React.Fragment>
)}
</TysiaToggle>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={40}
 text="Patients with multiple same-day appointments receive only one reminder—the first one."
/>
{children}
</React.Fragment>)
}